import { createContext, useContext } from "react"

// True below a <Page className="pc-page--refined …">. Shared MUI-era pieces
// (e.g. SectionCard) read it to adopt the refined card chrome without every
// call site changing — screens that haven't opted in render exactly as before.
export const RefinedContext = createContext(false)
export const useRefined = () => useContext(RefinedContext)
